import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import {
    useAddParentAccountsForSubdivisionMutation,
    useCheckUserIsManagerQuery,
    useGenerateCadPrintoutPdfServiceMutation,
    useGenerateTgxPdfServiceMutation,
    useGetCertificateOptionsByOrderIdQuery,
    useGetOrderByOrderIdAndTypeQuery,
    useGetOrderResultByOrderIdQuery,
    useIsPdfExistMutation,
    useLazyCheckPrimaryCollectorExistActionQuery,
    useLazyCheckTaxOrderResultValidQuery,
    useLazyGetCadInformationQuery,
    useLazyGetOrdersInSubdivisionListQuery,
    useLazyGetSimilarTaxAccountListQuery,
    useSaveOrderResultServiceMutation,
    useUpdateProductStatusMutation
} from "../../ordersApi";
import {
    computeBuyerSellerNote,
    computePropertyAddressNote,
    doesCurrentTaxYearMatchCurrentYear,
    fetchPdf,
    getCurrentTaxYear,
    returnNestedKeyValues,
    showToast,
    sortByKeysPriority,
    sortCollectorSummaryList,
    sortTaxSuits,
    trimSpace
} from "../../../../helpers/utils/Utils";
import { useParams } from "react-router-dom";
import {
    useGetOrderNoteByTypeAndIdQuery, useGetPropertyPickerResultMutation,
    useLazyGetLinkedAccountsServiceQuery,
    useLazyGetProductTaskListQuery,
    useLazyGetQCLogicResultListQuery
} from "../../productsApi";
import {
    autoCalculateSummaryRow,
    calculateCurrentWithExemptionEstimateValue,
    calculateCurrentWoExemptAmountValue, calculateTotalTaxValue, jsonCloneWithDates,
    recalculateAssessment,
    removeDuplicateAndNegativeItems,
    setTaskList,
    sortCadInfo,
    updateSummarySectionRow,
    updateSummaryTotalRowCalculation
} from "../../../../helpers/utils/OrderDetailUtils";
import LeftBar from "../Common/LeftNavBar/LeftBar";
import SummaryInfoSection from "../Sections/SummaryInfoSection";
import { RequestedInfoSection } from "../Sections/RequestedInfoSection";
import AccountInformation from "./AccountInformation";
import { CommentNoteSection } from "../Sections/CommentNoteSection";
import { BondSection } from "../Sections/BondSection";
import { TaxSuitsSection } from "../Sections/TaxSuitsSection";
import moment from "moment";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import TopSection from "../Common/TopSection/TopSection";
import EditorAddEditNoteForm from "../../modal/EditorAddEditNoteForm";
import { useUtilDataQuery } from "../../../profile/profileApi";
import { JurisdictionSection } from "../Sections/JurisdictionSection";
import { useLazyGetAllCountyByStateAbbrQuery } from "../../../data/counties/countiesApi";
import GenerateActivePdf from "../Common/Modals/GenerateActivePdf";
import { isArray } from "lodash";
import { useDispatch } from "react-redux";
import PdfDeliveryConfirmationModal from "../Common/Modals/PdfDeliveryConfirmationModal";
import Preloader from "../../../../components/common/Preloader";
import { tgxApi } from "../../../../app/tgxApi";
import { alphabeticalOrder, getAssessmentList } from "./Utils";
import LockConfirmationPopUp from "../../modal/LockConfirmationPopUp";

const TaxDetailTabSection: FC = () => {

    let { orderId } = useParams();
    const dispatch = useDispatch();

    const [accounts, setAccounts] = useState([]);
    const [certificateNotes, setCertificateNotes] = useState([]);
    const [primaryCollectorId, setPrimaryCollectorId] = useState("");
    const [showAccount, setShowAccount] = useState<any>(0);
    const [certificate, setCertificate] = useState<any>({
        "accounts": accounts, "certificateNotes": certificateNotes, "propertyIds": []
    });
    const [jurisdictionIdIndex, setJurisdictionIdIndex] = useState(0);
    const [updatedAccountIndexList, setUpdatedAccountIndexList] = useState<any>([]);
    const [removeJurisdiction, setRemoveJurisdiction] = useState(false);
    const [removedAccountIds, setRemovedAccountIds] = useState<any>([]);
    const [isSavedResult, setIsSavedResult] = useState(false);
    const [customerNoteList, setCustomerNoteList] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [certNoteList, setCertNoteList] = useState([]);
    const [productId, setProductId] = useState("");
    const [toggleAccountSection, setToggleAccountSection] = useState(true);
    const [isSendNotification, setIsSendNotification] = useState(false);
    const [products, setProducts] = useState<any>();
    const [similarAccountList, setSimilarAccountList] = useState([]);
    const [tempList, setTempList] = useState([]);
    const [isFetchSimilarAccountList, setIsFetchSimilarAccountList] = useState(false);
    const [vendorTaskList, setVendorTaskList] = useState([]);
    const [editable, setEditable] = useState(true);
    const [assignTo, setAssignTo] = useState("");
    const [qcResultList, setQcResultList] = useState([]);
    const [unAcknowledged, setUnAcknowledged] = useState([]);
    const [isValidDataForPdfGenerate, setIsValidDataForPdfGenerate] = useState<any>(false);
    const [showDeliveryConfirmation, setShowDeliveryConfirmation] = useState(false);
    const [isFetchLinkedAccountList, setIsFetchLinkedAccountList] = useState(false);
    const [orderResultModifiedDate, setOrderResultModifiedDate] = useState(null);
    const [productStatus, setProductStatus] = useState("");
    const [isAccountNoteDeleted, setIsAccountNoteDeleted] = useState(false);
    const [haveOrderResult, setHaveOrderResult] = useState(false);
    const [reloadCadInformation, setReloadCadInformation] = useState(false);
    const [loadingCadInfo, setLoadingCadInfo] = useState(false);
    const [isPropertyResultAvailable, setIsPropertyResultAvailable] = useState(false);
    const [showAddTaxSuitCommentModal, setShowAddTaxSuitCommentModal] = useState(false);
    const [showUpdateTaxSuitCommentModal, setShowUpdateTaxSuitCommentModal] = useState(false);
    const [taxNotesDeleted, setTaxNotesDeleted] = useState(false);
    const [autoCalculate, setAutoCalculate] = useState(false);
    const [updateTotalTotalTaxValue, setUpdateTotalTaxValue] = useState(false);
    const [isAddNewSummaryRow, setIsAddNewSummaryRow] = useState(false);
    const [taxYear, setTaxYear] = useState("");
    const [propertyResultTaxList, setPropertyResultTaxList] = useState<any>([]);
    const [taxCheckedList, setTaxCheckedList] = useState<any>([]);
    const [clearJurisRow, setClearJurisRow] = useState(false);
    const [render, setRender] = useState<any>("");
    const [primaryCollector, setPrimaryCollector] = useState(null);
    const [noteIndex, setNoteIndex] = useState(0);
    const [defaultJurisdictionSize, setDefaultJurisdictionSize] = useState([]);
    const [selectedCloneAccountList, setSelectedCloneAccountList] = useState([]);
    const [showAccountCloneModal, setShowAccountCloneModal] = useState(false);
    const [warningBondModal, setWarningBondModal] = useState(false);
    const [customerId, setCustomerId] = useState("");
    const [curProduct, setCurProduct] = useState({});
    const [moduleAvailableForCounty, setModuleAvailableForCounty] = useState(false);
    const [assignedTeam, setAssignedTeam] = useState(null);
    const [showTeamListModal, setShowTeamListModal] = useState(false);
    const [addedNewAccount, setAddedNewAccount] = useState(false);
    const [addAccountSelectedProperty, setAddAccountSelectedProperty] = useState(null);
    const [customerOrderNumber, setCustomerOrderNumber] = useState("");
    const [showDeleteAccountConfirmation, setShowDeleteAccountConfirmation] = useState(false);
    const [taxAccountNumber, setTaxAccountNumber] = useState("");
    const [address, setAddress] = useState("");
    const [legalDescription, setLegalDescription] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [isTaxSummaryReset, setIsTaxSummaryReset] = useState(false);
    const [isJurisdictionUpdated, setIsJurisdictionUpdated] = useState(false);
    const [warningModal, setWarningModal] = useState(false);
    const [docList, setDocList] = useState([]);
    const [deliveryEmail, setDeliveryEmail] = useState([]);
    const [activeTaskConfirmation, setActiveTaskConfirmation] = useState(false);
    const [requiresQc, setRequiresQc] = useState(false);
    const [orderStatus, setOrderStatus] = useState("");
    const [lockEditorPopUp, setLockEditorPopUp] = useState(false);
    const [isPdfExist, setIsPdfExist] = useState(true);
    const [disable, setDisable] = useState(false);
    const [warningModalBody, setWarningModalBody] = useState<any>(null);
    const [tenant, setTenant] = useState("");
    const [triggerCheckPrimaryCollectorApi, triggerCheckPrimaryCollectorApiResponse] = useLazyCheckPrimaryCollectorExistActionQuery();
    const [ordersInSubdivisionApi, ordersInSubdivisionApiResponse] = useLazyGetOrdersInSubdivisionListQuery();
    const [ordersInSubdivisionList, setOrdersInSubdivisionList] = useState([]);
    const [subdivisionId, setSubdivisionId] = useState<any>();
    const [cadInfoData, cadDataInfoApi] = useLazyGetCadInformationQuery();
    const orderResult = useGetOrderResultByOrderIdQuery(orderId)
    const isUserManager = useCheckUserIsManagerQuery(orderId);
    const certificateOptions = useGetCertificateOptionsByOrderIdQuery(orderId);
    const [similarTaxAccountListApi, similarTaxAccountListResponse] = useLazyGetSimilarTaxAccountListQuery();
    const orderQuery = useGetOrderByOrderIdAndTypeQuery({ orderId: orderId, orderType: 'OTHER' });
    const { data: notesData } = useGetOrderNoteByTypeAndIdQuery({
        orderId,
        noteTypes: ["TAX", "CUSTOMER"],
    });

    const latestCertificateRef = useRef(certificate);
    useEffect(() => {
        latestCertificateRef.current = certificate;
    }, [certificate]);

    const [productTaskListApi, productTaskListApiResponse] = useLazyGetProductTaskListQuery();
    const [qcLogicResultDataApi, qcLogicResultDataApiResponse] = useLazyGetQCLogicResultListQuery();

    const clonedOrderResultData = JSON.parse(JSON.stringify(orderResult));
    const { data: utilData } = useUtilDataQuery("");
    const [generatePDf, generatePDfApi] = useGenerateTgxPdfServiceMutation();
    const [generateCadPrintoutPDf, generateCadPrintoutPDfApi] = useGenerateCadPrintoutPdfServiceMutation();
    const [markAsCompleted, markAsCompletedApi] = useUpdateProductStatusMutation();
    const [checkTaxOrderResultValid] = useLazyCheckTaxOrderResultValidQuery();
    const [checkPdfExist, { data: pdfExistData }] = useIsPdfExistMutation();
    const [countyDataApi, countyDataApiResponse] = useLazyGetAllCountyByStateAbbrQuery();
    const [linkedAccountDataApi, { data: linkedAccounts, isSuccess, isFetching }] = useLazyGetLinkedAccountsServiceQuery();
    const [saveOrderResult, saveOrderResultApi] = useSaveOrderResultServiceMutation();
    const [addParentAccountsForSubdivisionApi] = useAddParentAccountsForSubdivisionMutation();
    const [getPropertyPickerResultApi, getPropertyPickerResult] = useGetPropertyPickerResultMutation();
    const [productStatuses, setProductStatuses] = useState(["PENDING", "SAVED", "COMPLETED", "QC","MARKED"]);

    useEffect(() => {
        checkPdfExist({
            'orderId': orderId,
            'orderFileType': ["TaxCertificate"],
            'type': 'New'
        });
    }, []);

    useEffect(() => {
        if (similarTaxAccountListResponse?.data) {
            setTempList(JSON.parse(JSON.stringify(similarTaxAccountListResponse.data)));
        }
    }, [similarTaxAccountListResponse]);

    useEffect(() => {
        if (pdfExistData !== undefined) {
            setIsPdfExist(pdfExistData);
        }

    }, [pdfExistData]);

    useEffect(() => {
        let obj = triggerCheckPrimaryCollectorApiResponse?.data;
        if (obj) {
            setPrimaryCollector(obj);
            setPrimaryCollectorId(obj?.id);
            setModuleAvailableForCounty(obj?.scraperModuleId != null && obj?.scraperModuleId != "")
        }
    }, [triggerCheckPrimaryCollectorApiResponse]);

    const deleteNote = (type: any, index: any) => {
        if (type === "accounts") {
            setIsAccountNoteDeleted(true);
        } else if (type === "taxSuitNotes") {
            setTaxNotesDeleted(true);
        } else {
            const temp = certificate.certificateNotes.filter((_: any, p: number) => p !== index);
            setCertificateNotes(temp);
            setCertificate({
                ...certificate,
                certificateNotes: temp,
            });
        }

        setUpdatedAccountIndexList((prevList: number[]) => {
            if (!prevList.includes(showAccount)) {
                return [...prevList, showAccount];
            }
            return prevList;
        });

        setIsSavedResult(false);
    };
    useEffect(() => {
        if (getPropertyPickerResult?.data?.length > 0) {

            updateAccountList(getPropertyPickerResult.data);
        }
    }, [getPropertyPickerResult]);

    useEffect(() => {
        if (orderStatus !== '' && (orderStatus === 'AWAITING_LOCATE' || orderStatus === 'NEW') && !isPropertyResultAvailable) {
            setLockEditorPopUp(true);
        }
    }, [orderStatus]);


    useEffect(() => {
        if (!cadDataInfoApi?.data) return;

        setCertificate((prev: any) => {
            const prevAccount = prev.accounts[showAccount];

            const updatedJurisdictions = prevAccount.jurisdictionList.map((el: any) => {
                const match = cadDataInfoApi.data.find(
                    (pl: any) =>
                        (pl.taxingUnit === el.jurisdictionName || pl.jurisdictionName === el.jurisdictionName) &&
                        pl.jurisdictionId
                );

                if (el.placeHolder === true && match) {
                    const collector = match.collectorDTO;
                    return {
                        ...el,
                        jurisdictionId: match.jurisdictionId,
                        jurisdictionName: match.jurisdictionName,
                        collectorName: collector?.name || collector,
                        collectorId: collector?.id || collector,
                        placeHolder: false
                    };
                }

                return el;
            });

            const updatedAccount = {
                ...prevAccount,
                cadInformation: cadDataInfoApi.data,
                jurisdictionList: updatedJurisdictions
            };

            const updatedAccounts = [...prev.accounts];
            updatedAccounts[showAccount] = updatedAccount;

            return {
                ...prev,
                accounts: updatedAccounts
            };
        });

        if (haveOrderResult) {
            const newPlaceholdersFilled = cadDataInfoApi.data.some((pl: any) =>
                pl.jurisdictionId &&
                pl.jurisdictionName &&
                pl.collectorDTO?.id &&
                pl.collectorDTO?.name
            );

            if (newPlaceholdersFilled) {
                setIsSavedResult(false);
            }
        }

        setIsAddNewSummaryRow(true);
        setAutoCalculate(true);
        setUpdateTotalTaxValue(true);

        setUpdatedAccountIndexList((prev: any) => {
            return prev.includes(showAccount) ? prev : [...prev, showAccount];
        });

    }, [cadDataInfoApi]);



    useEffect(() => {
        if (isTaxSummaryReset) {
            certificate.accounts[showAccount].summaryList = [{
                collector: "",
                collectorAccountNumber: "",
                taxYear: "",
                baseTax: "",
                baseTaxDue: "",
                paidBy: "",
                paidBy1: "",
                asOfDate: "",
                baseDue: ""
            }];

            certificate.accounts[showAccount].baseTaxTotal = null;
            certificate.accounts[showAccount].baseTaxDueTotal = null;
            certificate.accounts[showAccount].currentMonthTotal = null;
            certificate.accounts[showAccount].nextMonthTotal = null;

            setCertificate((certificate: any) => {
                return certificate
            });
            setIsTaxSummaryReset(false);
        }
    }, [isTaxSummaryReset]);

    useEffect(() => {
        if (isAccountNoteDeleted) {
            certificate.accounts[showAccount].accountNotes = certificate.accounts[showAccount].accountNotes.filter((v: any, i: any) => {
                return i !== noteIndex;
            });
            setCertificate(certificate);
            setIsAccountNoteDeleted(false);
        }
        if (taxNotesDeleted) {
            certificate.accounts[showAccount].taxSuitNotes = certificate.accounts[showAccount].taxSuitNotes.filter((v: any, i: any) => {
                return i !== noteIndex;
            });
            setCertificate(certificate);
            setTaxNotesDeleted(false);
        }

    }, [isAccountNoteDeleted, taxNotesDeleted]);

    useEffect(() => {

        if (removeJurisdiction) {
            let data = bondExist(certificate.accounts[showAccount].bondList, certificate.accounts[showAccount].jurisdictionList[jurisdictionIdIndex]['jurisdictionId']);
            if (data.length > 0) {
                setWarningBondModal(true);
                setRemoveJurisdiction(false);
            } else {
                removeJurisdictionAndBonds();
            }
        }
    }, [removeJurisdiction]);

    useEffect(() => {
        if (autoCalculate) {
            const updatedCertificate = autoCalculateSummaryRow(certificate, showAccount);
            setCertificate(updatedCertificate);
            setAutoCalculate(false);
        }
    }, [autoCalculate]);


    const removeJurisdictionAndBonds = () => {
        const currentAccount = certificate.accounts[showAccount];
        const currentJurisdiction = currentAccount.jurisdictionList[jurisdictionIdIndex];

        // Filter bondList immutably
        const newBondList = currentAccount.bondList.filter(
            (el: any) => el.jurisdictionId !== currentJurisdiction.jurisdictionId
        );

        let newAccount: any;

        if (currentAccount.jurisdictionList.length === 1) {
            newAccount = {
                ...currentAccount,
                bondList: newBondList.length === 0 ? [{
                    jurisdictionName: "",
                    jurisdictionId: "",
                    bondsApproved: null,
                    bondsIssued: null,
                    standbyFee: null,
                }] : newBondList,
                accountNotes: currentAccount.accountNotes.filter(
                    (note: any) => note.relationalId !== currentJurisdiction.jurisdictionId
                ),
                summaryList: [{
                    collector: "",
                    collectorAccountNumber: "",
                    taxYear: "",
                    baseTaxDue: null,
                    baseTax: null,
                    currentMonthDue: null,
                    nextMonthTaxDue: null,
                    asOfDate: null,
                }],
                jurisdictionList: [{
                    collectorName: "",
                    jurisdictionId: "",
                    collectorId: "",
                    jurisdictionName: "",
                    tax_rate: "",
                    bill_year: "",
                    baseDue: "",
                    baseTax: null,
                    currentMonthDue: null,
                    nextMonthDue: null,
                    collectorAccountNumber: "",
                    nonCollecting: false,
                    inActive: false,
                    tax_rate_List: [],
                    taxDataSource: null,
                    asOfDate: null,
                    placeHolder: false,
                }],
                taxRateTotal: null,
                cadInformation: [],
                baseTaxTotal: null,
                baseTaxDueTotal: null,
                currentMonthTotal: null,
                nextMonthTotal: null,
            };
        } else {
            const updatedJurisdictions = currentAccount.jurisdictionList.filter((_: any, i: number) => i !== jurisdictionIdIndex);
            const updatedNotes = currentAccount.accountNotes.filter(
                (note: any) => note.relationalId !== currentJurisdiction.jurisdictionId
            );

            const { collectorName, bill_year } = currentJurisdiction;
            const summaryIndex = currentAccount.summaryList.findIndex(
                (item: any) =>
                    item.collector === collectorName &&
                    parseInt(item.taxYear) === parseInt(bill_year)
            );

            const filteredJurisdictions = updatedJurisdictions.filter(
                (j: any) =>
                    j.collectorName === collectorName &&
                    parseInt(j.bill_year) === parseInt(bill_year)
            );

            let updatedSummaryList: any = [...currentAccount.summaryList];

            if (filteredJurisdictions.length === 0 && summaryIndex !== -1) {
                updatedSummaryList = updatedSummaryList.filter((_: any, i: number) => i !== summaryIndex);
            } else if (summaryIndex !== -1) {
                updatedSummaryList = updateSummaryRowInfo(updatedSummaryList,
                    filteredJurisdictions,
                    summaryIndex);
            }
            newAccount = {
                ...currentAccount,
                bondList: newBondList.length === 0 ? [{
                    jurisdictionName: "",
                    jurisdictionId: "",
                    bondsApproved: null,
                    bondsIssued: null,
                    standbyFee: null,
                }] : newBondList,
                accountNotes: updatedNotes,
                jurisdictionList: updatedJurisdictions,
                summaryList: updatedSummaryList,
            };

            setUpdateTotalTaxValue(true);
            newAccount = updateSummaryTotalRowCalculation(newAccount, updatedSummaryList);
        }

        const updatedAccounts = certificate.accounts.map((acc: any, i: number) =>
            i === showAccount ? newAccount : acc
        );

        const updatedCertificate = {
            ...certificate,
            accounts: updatedAccounts
        };

        setRemoveJurisdiction(false);
        setWarningBondModal(false);
        setRender(new Date().getMilliseconds());

        [0, 1].forEach(index => {
            const assessment = newAccount.assessments?.[index];
            if (assessment) {
                calculateCurrentWoExemptAmountValue(updatedCertificate, showAccount, assessment, setRender, setCertificate);
                calculateCurrentWithExemptionEstimateValue(updatedCertificate, showAccount, assessment, setRender, setCertificate);
            }
        });
        setCertificate(updatedCertificate);

    };

    async function addParentAccountsForSubdivision(subdivisionId: any, setDisable: any, setShow: any) {
        try {
            setDisable(true);
            const updatedCertificate = jsonCloneWithDates(certificate);
            updatedCertificate.accounts[showAccount] = {
                ...updatedCertificate.accounts[showAccount],
                subdivisionId: subdivisionId,
            };

            setCertificate(updatedCertificate);
            const orderResults = handleOrderResultSubmit(true, updatedCertificate);

            const response: any = await addParentAccountsForSubdivisionApi({ subdivisionId, orderResults }).unwrap();

            if (response?.errorCode === 200) {
                setDisable(false);
                showToast(`${response.noOfAccountsAdded} new Certificate Accounts have been added!`, 'success');
                setShow(false);
            } else {
                setDisable(false);
                setShow(false);
            }
        } catch (error: any) {
            setDisable(false);
            setShow(false);
            showToast(error?.message || "Something went wrong", 'error');
        }
    }

    useEffect(() => {
        if (selectedCloneAccountList.length <= 0) return;

        const temp: any[] = [];
        const newRemovedAccountIds = [...removedAccountIds];
        const updatedIndices: number[] = [];

        setCertificate((prev: any) => {
            const prevAccounts = [...prev.accounts];
            const prevPropertyIds = [...prev.propertyIds];

            selectedCloneAccountList.forEach((el: any) => {
                const accountDTO = {
                    ...el.certificateAccountDTO,
                    id: null,
                    orderPropertyId: null,
                };

                const index = prevAccounts.findIndex(
                    (pDay) => trimSpace(accountDTO.propertyId) === trimSpace(pDay.propertyId)
                );

                if (index > -1) {
                    const existingId = prevAccounts[index].id;
                    if (existingId != null && existingId !== "") {
                        newRemovedAccountIds.push(existingId);
                    }
                    prevAccounts[index] = accountDTO;
                    updatedIndices.push(index);
                } else {
                    prevAccounts.push(accountDTO);
                    updatedIndices.push(prevAccounts.length - 1);
                    prevPropertyIds.push({ id: el.certificateAccountDTO.propertyId, visibility: true });
                }
            });

            const updatedCertificate = {
                ...prev,
                accounts: prevAccounts,
                propertyIds: prevPropertyIds,
            };

            prevAccounts.forEach((account, i) => {
                const { updatedAccountEntry, updatedPropertyId } = accountInfo(account, i, true, temp, updatedCertificate);
                updatedCertificate.accounts[i] = updatedAccountEntry;
                updatedCertificate.propertyIds[i] = { id: updatedPropertyId, visibility: true };
            });

            recalculateAssessment(showAccount, setRender, updatedCertificate, setCertificate);

            return updatedCertificate;
        });

        setRemovedAccountIds(newRemovedAccountIds);
        setShowAccount(0); // shift to last added account
        setUpdatedAccountIndexList(updatedIndices);
        setIsSavedResult(false);
        setShowAccountCloneModal(false);
        showToast("Successfully cloned all accounts!");
    }, [selectedCloneAccountList]);




    useEffect(() => {
        if (notesData && notesData.error === undefined) {
            setCertNoteList(notesData?.filter((el: any) => el.noteType === "TAX"));
            setCustomerNoteList(notesData?.filter((el: any) => el.noteType === "CUSTOMER"));
        }
    }, [notesData]);



    useEffect(() => {

        if (orderQuery?.data) {
            let product = orderQuery?.data?.products?.filter((obj: any) => obj.type.includes("TAX_"))[0];
            setProducts(product)
            setCustomerId(orderQuery.data?.customerDTO?.id);
            setCustomerOrderNumber(orderQuery.data?.customerOrderNumber);
            setTenant(orderQuery.data.tenant);
            setProductStatus(product?.productStatus);
            setCurProduct(product);
            setTaxAccountNumber(orderQuery.data?.properties[0]?.taxIdentifier);
            setAddress(orderQuery.data?.properties[0]?.addressLine1);
            setLegalDescription(orderQuery.data?.properties[0]?.legalDescription);
            setOwnerName(orderQuery.data?.properties[0]?.sellerName);
            setIsPropertyResultAvailable(orderQuery.data?.properties[0]?.propertyResult !== null && orderQuery.data?.properties[0]?.propertyResult !== "");

            countyDataApi(orderQuery.data.state);
            productTaskListApi(product?.id);
            qcLogicResultDataApi(product?.id);

            orderQuery.data?.properties?.map((property: any, index: number) => {
                if (index === 0) {
                    if (property.propertyResult != null && property.propertyResult.parsedAddress !== null && property.propertyResult.parsedAddress !== '' && property.propertyResult.parsedAddress.county !== null && property.propertyResult.parsedAddress.county !== '') {

                        triggerCheckPrimaryCollectorApi({
                            county: property.propertyResult.parsedAddress.county,
                            stateAbbreviation: property.propertyResult.parsedAddress.state
                        });

                    } else {
                        triggerCheckPrimaryCollectorApi({
                            county: orderQuery.data.county,
                            stateAbbreviation: orderQuery.data.state
                        });
                    }
                }
            })



            let assignTo = product.assignedTo;
            setEditable(orderQuery.data.active && assignTo === utilData?.userName);
            setAssignTo(assignTo);
            setProductId(product.id);
            setRequiresQc(product.requiresQc);
            setOrderStatus(orderQuery.data.orderStatus);
        }
    }, [orderQuery?.data, utilData]);

    useMemo(() => {
        if (showAccount !== null) {
            if (certificate.accounts.length > 0) {
                setSimilarAccountList(tempList.length > 0 ? tempList.filter((el: any) => el?.propertyId === certificate?.accounts[showAccount]?.propertyId) : []);
            }

            setSubdivisionId(certificate.accounts[showAccount]?.subdivisionDTO?.id)
        }
    }, [showAccount]);


    useEffect(() => {

        setSimilarAccountList(tempList.length > 0 ? tempList.filter((el: any) => el.propertyId === certificate.accounts[showAccount]?.propertyId) : []);

    }, [tempList]);


    useEffect(() => {
        if (!isFetchSimilarAccountList) {
            return;
        }

        let propertyIds: any = [];
        certificate.accounts.filter((el: any) => {
            if (el.original) {
                if (el.propertyId) {
                    propertyIds.push(el.propertyId);
                }
            }
        });


        if (propertyIds.length > 0) {
            similarTaxAccountListApi({ orderId: orderId, propertyIds });
        }

        setIsFetchSimilarAccountList(false);
    }, [isFetchSimilarAccountList]);


    useEffect(() => {

        if (productTaskListApiResponse?.data) {
            setTaskList(productTaskListApiResponse?.data, setVendorTaskList, orderQuery?.data?.properties);
        }

    }, [productTaskListApiResponse]);

    const handleMarkAsComplete = async () => {
        try {
            const result = await markAsCompleted({
                productId: productId,
                productStatus: "COMPLETED"
            }).unwrap();

            if (result?.errorCode === 200) {
                showToast("Mark as completed successfully!", "success");
                setProductStatus("COMPLETED");
                if (setShowAccount) {
                    setShowAccount(0);
                }
            }
        } catch (error: any) {
            showToast(error?.message || "Something went wrong.", "error");
        }
    };

    useEffect(() => {
        if (addedNewAccount) {
            const assessment = dummyAssessmentList();

            const juris = {
                jurisdictionId: "", levies: [], bonds: []
            };

            const accountObj = {
                sort: certificate.accounts.length,
                orderId: orderId,
                customerOrderNumber: customerOrderNumber,
                propertyId: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.taxId"),
                ownerName: "",
                ownerAddress: "",
                subdivisionId: "",
                acreage: "",
                geographicId: "",
                subdivisionCode: "",
                stateCodes: [],
                deed: "",
                legalDescription: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.legalDescription"),
                situsAddress: returnNestedKeyValues(addAccountSelectedProperty, "propertyResult.address"),
                taxYear: getCurrentTaxYear(),
                orderPropertyId: returnNestedKeyValues(addAccountSelectedProperty, "id"),
                accountNotes: [],
                taxSuitNotes: [],
                assessments: assessment,
                jurisdictions: juris,
                taxDataSource: "EDITOR",
                asOfDate: null,
                jurisdictionList: [{
                    collectorName: "",
                    jurisdictionName: "",
                    collectorAccountNumber: "",
                    nonCollecting: false,
                    inActive: false,
                    jurisdictionId: "",
                    tax_rate: "",
                    bill_year: "",
                    baseDue: "",
                    placeHolder: false,
                    baseTax: "",
                    currentMonthDue: "",
                    nextMonthTaxDue: "",
                    collectorId: "",
                    tax_rate_List: [],
                    taxDataSource: "EDITOR",
                    asOfDate: null,
                    collectorLink: null,
                }],
                summaryList: [{
                    collector: "",
                    collectorAccountNumber: "",
                    taxYear: "",
                    baseTaxDue: "",
                    baseTax: null,
                    currentMonthDue: "",
                    nextMonthTaxDue: "",
                    asOfDate: null,
                    baseDue: ""
                }],
                bondList: [{
                    jurisdictionName: "",
                    jurisdictionId: "",
                    bondsApproved: null,
                    bondsIssued: null,
                    standbyFee: null
                }],
                taxSuits: [{
                    payeeId: "",
                    payee: "",
                    suitNumber: "",
                    parcel: "",
                    feeType: null,
                    amount: null,
                    balance: null
                }],
                taxRateTotal: null,
                cadInformation: [],
                baseTaxTotal: null,
                baseTaxDueTotal: null,
                currentMonthTotal: null,
                nextMonthTotal: null,
                original: true
            };

            // Create new arrays to avoid mutation
            const newAccounts = [...certificate.accounts, accountObj];
            const newPropertyIds = [...certificate.propertyIds, { id: accountObj.propertyId, visibility: true }];

            // Update certificate immutably
            const newCertificate = {
                ...certificate,
                accounts: newAccounts,
                propertyIds: newPropertyIds
            };

            setCertificate(newCertificate);
            setAddedNewAccount(false);
            setShowAccount(newCertificate.accounts.length - 1);

            // Update updatedAccountIndexList immutably if it's state or ref
            if (Array.isArray(updatedAccountIndexList)) {
                setUpdatedAccountIndexList((prev: number[]) => {
                    if (!prev.includes(newAccounts.length - 1)) {
                        return [...prev, newAccounts.length - 1];
                    }
                    return prev;
                });
            } else if (updatedAccountIndexList.current) {
                // if it's a ref
                if (!updatedAccountIndexList.current.includes(newAccounts.length - 1)) {
                    updatedAccountIndexList.current.push(newAccounts.length - 1);
                }
            }

            setIsSavedResult(false);
        }
    }, [addedNewAccount]);


    useMemo(() => {
        if (qcLogicResultDataApiResponse?.data) {
            setQcResultList(qcLogicResultDataApiResponse?.data);
            setUnAcknowledged(JSON.parse(JSON.stringify(qcLogicResultDataApiResponse?.data)).filter((el: any) => el.result && (el.acknowledgedBy == null || el.acknowledgedBy === "")));
        }
    }, [qcLogicResultDataApiResponse]);

    useEffect(() => {
        const fetchCadInfo = async () => {
            if (reloadCadInformation && certificate.accounts?.[showAccount]) {
                const account = certificate.accounts[showAccount];
                const cadInfoList = account.cadInformation;
                const countyId = account.countyId ?? orderQuery.data?.countyId;

                setLoadingCadInfo(true);
                try {
                    await cadInfoData({
                        list: cadInfoList,
                        countyId: countyId
                    }).unwrap();
                    showToast("CAD Information Successfully Updated!");
                } catch (error) {
                    console.error("Failed to fetch CAD info", error);
                    showToast("Failed to fetch CAD info", "error");
                } finally {
                    setLoadingCadInfo(false);
                    setReloadCadInformation(false);
                }
            }
        };

        fetchCadInfo();
    }, [reloadCadInformation]);

    useEffect(() => {
        if (orderQuery.data !== undefined && orderQuery.data && orderQuery.data.error === undefined) {
            if (orderResult?.data === null && certificate.accounts.length !== orderQuery?.data?.properties?.length) {
                let updatedAccounts: any[] = [...certificate.accounts];
                let updatedPropertyIds: any[] = [...certificate.propertyIds];
                let propertyResultTaxSet = new Set([...propertyResultTaxList]);
                let taxCheckedSet = new Set([...taxCheckedList]);
                let newIndices: number[] = [];

                orderQuery?.data?.properties?.forEach((property: any, index: number) => {
                    if (property?.propertyResult?.skipAutomation) return;

                    const propertyResult = property.propertyResult;
                    const propertyId = propertyResult?.taxId || '';
                    const geoId = propertyResult?.geoId || '';
                    const legalDesc = propertyResult?.legalDescription ?? property.legalDescription;
                    const situsAddress = propertyResult?.address ?? property.addressLine1;

                    if (propertyId) {
                        propertyResultTaxSet.add(propertyId);
                        taxCheckedSet.add(propertyId);
                    }

                    updatedPropertyIds.push({ id: propertyId, visibility: true });

                    const accountObj = {
                        sort: index,
                        orderId,
                        customerOrderNumber,
                        propertyId,
                        ownerName: propertyResult?.primaryOwner ?? orderQuery.data.sellerName,
                        ownerAddress: "",
                        subdivisionId: "",
                        acreage: "",
                        geographicId: geoId,
                        subdivisionCode: "",
                        stateCodes: [],
                        deed: "",
                        legalDescription: legalDesc,
                        situsAddress: situsAddress,
                        taxYear: getCurrentTaxYear(),
                        taxDataSource: "EDITOR",
                        asOfDate: null,
                        orderPropertyId: property.id,
                        accountNotes: [],
                        taxSuitNotes: [],
                        assessments: dummyAssessmentList(),
                        jurisdictions: {
                            jurisdictionId: "", levies: [], bonds: []
                        },
                        jurisdictionList: [{
                            collectorName: "",
                            jurisdictionName: "",
                            jurisdictionId: "",
                            tax_rate: "",
                            bill_year: "",
                            baseDue: "",
                            baseTax: "",
                            currentMonthDue: "",
                            nextMonthTaxDue: "",
                            collectorAccountNumber: "",
                            nonCollecting: false,
                            inActive: false,
                            collectorId: "",
                            tax_rate_List: [],
                            asOfDate: null,
                            taxDataSource: null,
                            placeHolder: false
                        }],
                        summaryList: [{
                            collector: "",
                            taxYear: "",
                            baseTaxDue: "",
                            baseTax: "",
                            currentMonthDue: "",
                            nextMonthTaxDue: "",
                            asOfDate: null
                        }],
                        bondList: [{
                            jurisdictionName: "",
                            jurisdictionId: "",
                            bondsApproved: null,
                            bondsIssued: null,
                            standbyFee: null
                        }],
                        taxSuits: [{
                            payeeId: "",
                            suitNumber: "",
                            parcel: "",
                            feeType: null,
                            amount: null,
                            balance: null
                        }],
                        cadInformation: [],
                        taxRateTotal: null,
                        baseTaxTotal: null,
                        baseTaxDueTotal: null,
                        currentMonthTotal: null,
                        nextMonthTotal: null,
                        original: true
                    };

                    newIndices.push(updatedAccounts.length);
                    updatedAccounts.push(accountObj);
                });

                const note = computeBuyerSellerNote(orderQuery.data.buyerName, orderQuery.data.sellerName);
                const propertyNote = computePropertyAddressNote(orderQuery, certificate);

                const updatedCertificate = {
                    ...certificate,
                    accounts: updatedAccounts,
                    propertyIds: updatedPropertyIds,
                    certificateNotes: []
                };

                if (note !== null) {
                    updatedCertificate.certificateNotes.push({
                        comment: note,
                        certificateLevelNote: true
                    });
                }

                if (propertyNote) {
                    updatedCertificate.certificateNotes.push({
                        comment: propertyNote,
                        certificateLevelNote: true
                    });
                }

                setPropertyResultTaxList(Array.from(propertyResultTaxSet));
                setTaxCheckedList(Array.from(taxCheckedSet));
                setCertificate(updatedCertificate);
                setShowAccount(0);

                setUpdatedAccountIndexList((prev: number[]) =>
                    Array.from(new Set([...prev, ...newIndices]))
                );

                setShowForm(true);
            }

            setIsFetchSimilarAccountList(true);
        }
    }, [orderQuery, orderResult]);



    useEffect(() => {
        if (
            clonedOrderResultData === undefined ||
            clonedOrderResultData.data === undefined ||
            !clonedOrderResultData?.data?.certificate?.accounts?.length ||
            clonedOrderResultData.data.certificate.accounts.length <= 0
        ) {
            return;
        }


        const validateTaxOrderResult = async () => {
            try {
                const { data } = await checkTaxOrderResultValid(clonedOrderResultData.data);
                setIsValidDataForPdfGenerate(data === true);
            } catch (error) {
                console.error("Error while validating order result:", error);
            }
        };

        validateTaxOrderResult();

        setHaveOrderResult(true);
        setOrderResultModifiedDate(orderResult.data.certificate.accounts[0].modifiedDate);

        // Prepare updatedCertificate as before
        const updatedCertificate = {
            ...certificate,
            accounts: [...(orderResult?.data?.certificate?.accounts ?? [])],
            certificateNotes: [...(orderResult?.data?.certificate?.certificateNotes ?? [])],
        };

        const temp: any = [];

        const updatedAccounts = [...updatedCertificate.accounts];
        const updatedPropertyIds: any[] = [];

        orderResult.data.certificate.accounts.forEach((account: any, i: number) => {
            const { updatedAccountEntry, updatedPropertyId } = accountInfo(account, i, account.original, temp, updatedCertificate);
            updatedAccounts[i] = updatedAccountEntry;
            updatedPropertyIds.push({ id: updatedPropertyId, visibility: true });
        });


        setCertificate({
            ...updatedCertificate,
            accounts: updatedAccounts,
            propertyIds: updatedPropertyIds,
        });

        setDefaultJurisdictionSize(temp);
        setIsSavedResult(true);
        setShowAccount(0);
        setShowForm(true);
    }, [orderResult?.data]);

    useEffect(() => {
        ordersInSubdivisionApi({
            subdivisionId:subdivisionId,
            productStatuses:productStatuses
        })
    }, [subdivisionId,productStatuses]);

    useEffect(() => {
        setOrdersInSubdivisionList(ordersInSubdivisionApiResponse.data)
    }, [ordersInSubdivisionApiResponse.data]);

    const accountInfo = (accounts: any, i: any, isOriginal: boolean, temp: any = [], updatedCertificate: any) => {
        const jurisNewList: any[] = [];
        let summaryList: any[] = [];
        const bondList: any[] = [];
        const taskList: any[] = [];

        const updatedPropertyId = isOriginal
            ? accounts.propertyId
            : typeof accounts.propertyId === 'string' && !accounts.propertyId.includes('-CLONE')
                ? `${accounts.propertyId}-CLONE`
                : accounts.propertyId;


        const updatedAccount = {
            ...accounts,
            propertyId: updatedPropertyId,
            original: isOriginal,
            orderId: orderId
        };

        if (Array.isArray(accounts.jurisdictions)) {
            accounts.jurisdictions.forEach((jurisdiction: any) => {
                temp.push(jurisdiction.jurisdictionName);

                const collectorName = jurisdiction.collector?.collectorName || jurisdiction.collector;
                const collectorId = jurisdiction.collector?.collectorId || jurisdiction.collector;
                const collectorLink = jurisdiction.collector?.collectorLink || null;

                if (Array.isArray(jurisdiction.levies) && jurisdiction.levies.length > 0) {
                    jurisdiction.levies.forEach((leviesList: any) => {
                        const levy = {
                            collectorName,
                            jurisdictionName: jurisdiction.jurisdictionName,
                            jurisdictionId: jurisdiction.jurisdictionId,
                            tax_rate: leviesList.taxRate,
                            bill_year: leviesList.billYear,
                            currentMonthDue: leviesList.currentMonthDue,
                            nextMonthTaxDue: leviesList.nextMonthDue,
                            baseTax: leviesList.baseTax,
                            baseDue: leviesList.baseDue,
                            collectorId,
                            tax_rate_List: [],
                            asOfDate: jurisdiction.asOfDate,
                            taxDataSource: jurisdiction.taxDataSource,
                            placeHolder: jurisdiction.placeHolder,
                            collectorAccountNumber: jurisdiction.collectorAccountNumber,
                            nonCollecting: jurisdiction.nonCollecting ?? false,
                            inActive: jurisdiction.inActive ?? false,
                            id: jurisdiction.id,
                            collectorLink
                        };
                        jurisNewList.push(levy);

                        if (!jurisdiction.placeHolder) {
                            const existingSummaryIndex = summaryList.findIndex(
                                (obj: any) => obj.collector === collectorName && obj.taxYear === leviesList.billYear
                            );

                            if (existingSummaryIndex === -1) {
                                const asOfDateArray = accounts.jurisdictions
                                    .filter((j: any) => j.asOfDate)
                                    .map((j: any) => moment(j.asOfDate, 'YYYY-MM-DD').valueOf());

                                const filteredJurisdictions = accounts.jurisdictions.filter((el: any) =>
                                    el.collector?.collectorId === collectorId && el.collectorAccountNumber
                                );
                                const collectorAccountNumber = filteredJurisdictions[0]?.collectorAccountNumber || jurisdiction.collectorAccountNumber;

                                summaryList.push({
                                    collector: collectorName,
                                    taxYear: leviesList.billYear,
                                    collectorAccountNumber,
                                    baseTaxDue: leviesList.baseDue,
                                    baseTax: leviesList.baseTax,
                                    currentMonthDue: leviesList.currentMonthDue,
                                    nextMonthTaxDue: leviesList.nextMonthDue,
                                    asOfDate: asOfDateArray.length > 0 ? new Date(Math.min(...asOfDateArray)) : null,
                                    baseDue: leviesList.baseDue,
                                });
                            } else {
                                const list = jurisNewList.filter((obj: any) =>
                                    obj.collectorName === collectorName &&
                                    obj.bill_year === leviesList.billYear &&
                                    obj.placeHolder === false
                                );
                                summaryList = updateSummaryRowInfo(summaryList, list, existingSummaryIndex);
                            }
                        }
                    });
                } else {
                    jurisNewList.push({
                        collectorName,
                        jurisdictionName: jurisdiction.jurisdictionName,
                        jurisdictionId: jurisdiction.jurisdictionId,
                        tax_rate: "",
                        bill_year: "",
                        currentMonthDue: "",
                        nextMonthTaxDue: "",
                        baseTax: "",
                        baseDue: "",
                        collectorId,
                        tax_rate_List: [],
                        asOfDate: jurisdiction.asOfDate,
                        taxDataSource: jurisdiction.taxDataSource,
                        placeHolder: jurisdiction.placeHolder,
                        collectorAccountNumber: jurisdiction.collectorAccountNumber,
                        nonCollecting: jurisdiction.nonCollecting ?? false,
                        inActive: jurisdiction.inActive ?? false,
                        id: jurisdiction.id,
                        collectorLink
                    });
                }

                if (Array.isArray(jurisdiction.bonds)) {
                    jurisdiction.bonds.forEach((bond: any) => {
                        bondList.push({
                            jurisdictionName: jurisdiction.jurisdictionName,
                            jurisdictionId: jurisdiction.jurisdictionId,
                            bondsApproved: bond.bondsApproved,
                            bondsIssued: bond.bondsIssued,
                            standbyFee: bond.standbyFee,
                            id: bond.id
                        });
                    });
                }
            });
        }

        const assessments = getAssessmentList(updatedCertificate, i);
        const jurisdictionList = jurisNewList.length > 0
            ? sortByKeysPriority(jurisNewList, ["bill_year", "collectorName", "jurisdictionName"], ["desc", "asc", "asc"])
            : [{
                collectorName: "", jurisdictionName: "", jurisdictionId: "", tax_rate: "", bill_year: "",
                baseDue: "", baseTax: "", currentMonthDue: "", nextMonthTaxDue: "", collectorAccountNumber: "",
                collectorId: "", tax_rate_List: [], asOfDate: null, taxDataSource: null, placeHolder: false,
                nonCollecting: false, inActive: false
            }];

        const bondListFinal = bondList.length > 0 ? bondList : [{
            jurisdictionName: "", jurisdictionId: "", bondsApproved: null, bondsIssued: null, standbyFee: null
        }];

        const summaryListFinal = summaryList.length > 0
            ? sortCollectorSummaryList(summaryList, ["isPrimaryCollector", "taxYear", "collectorName"], ["desc", "desc", "asc"])
            : [{
                collector: "", collectorAccountNumber: "", taxYear: "", baseTax: null,
                baseTaxDue: null, currentMonthDue: null, nextMonthTaxDue: null, asOfDate: null
            }];

        if (accounts?.taxSuits?.length > 0) {
            accounts.taxSuits.forEach((taxSuit: any) => {
                taskList.push({
                    payeeId: taxSuit.payeeId,
                    payee: taxSuit.collector?.collectorName || taxSuit.collector,
                    suitNumber: taxSuit.suitNumber,
                    parcel: taxSuit.parcel,
                    feeType: taxSuit.feeType || null,
                    amount: taxSuit.amount,
                    balance: taxSuit.balance,
                    id: taxSuit.id
                });
            });
        }

        const taxSuitsFinal = taskList.length > 0 ? sortTaxSuits(taskList) : [{
            payeeId: "", payee: "", suitNumber: "", parcel: "", feeType: null, amount: null, balance: null
        }];

        const taxRateTotal = getUniqueLatestYearJurisdictions(jurisNewList).reduce(function (prev, current) {
            if (current.tax_rate !== '' && current.tax_rate !== null && prev !== null) {
                return prev + parseFloat(current.tax_rate)
            } else if (current.tax_rate === '' || current.tax_rate === null || prev === null) {
                return null;
            } else {
                return prev;
            }
        }, 0);

        let updatedAccountEntry = {
            ...updatedAccount,
            assessments,
            sort: i,
            jurisdictionList,
            bondList: bondListFinal,
            summaryList: summaryListFinal,
            taxSuits: taxSuitsFinal,
            cadInformation: accounts.cadInformation,
            taxRateTotal
        };

        const updatedAccounts = [...updatedCertificate.accounts];
        updatedAccounts[i] = updatedAccountEntry;

        updatedAccountEntry = updateSummaryTotalRowCalculation(updatedAccountEntry, summaryListFinal);
        return {
            updatedAccountEntry,
            updatedPropertyId
        };
    };
    useEffect(() => {
        recalculateAssessment( showAccount, setRender,certificate, setCertificate);
    }, [showAccount]);

    // Trigger fetch on change
    useEffect(() => {
        if (isFetchLinkedAccountList) {
            const propertyId = certificate.accounts
                .filter((el: any) => el.original && el.propertyId)
                .map((el: any) => el.propertyId);

            if (propertyId.length > 0) {
                linkedAccountDataApi({ primaryCollectorId: primaryCollectorId, accountIds: propertyId });
            }
        }
    }, [isFetchLinkedAccountList]);

    useEffect(() => {
        if (isSuccess) {
            if (linkedAccounts?.length > 0) {
                updateAccountList(linkedAccounts);
                showToast("Successfully added all linked accounts!");
            } else {
                showToast("No account found to link!");
            }
            setIsFetchLinkedAccountList(false);
        }
    }, [linkedAccounts, isSuccess]);



    const updateAccountList = (data: any) => {
        const temp: any[] = [];

        const newAccounts = [...certificate.accounts];
        const updatedAccountIndexList: number[] = [];
        const propertyIds: any[] = [...certificate.propertyIds];

        data.forEach((account: any) => {
            setUpdatedAccountIndexList((prev: number[]) =>
                prev.includes(newAccounts.length) ? prev : [...prev, newAccounts.length - 1]
            );
            newAccounts.push(account);
            propertyIds.push({ id: account.propertyId, visibility: true });
        });



        const updatedAccounts: any[] = [];
        const updatedPropertyIds: any[] = [];

        let updatedCertificate = { ...certificate, accounts: newAccounts, propertyIds: propertyIds };

        newAccounts.forEach((account, i) => {
            const { updatedAccountEntry, updatedPropertyId } = accountInfo(account, i, true, temp, updatedCertificate);
            updatedAccounts[i] = updatedAccountEntry;
            updatedPropertyIds.push({ id: updatedPropertyId, visibility: true });
        });

        setCertificate({
            ...certificate,
            accounts: updatedAccounts,
            propertyIds: updatedPropertyIds,
        });

        setShowAccount(0);
        setIsSavedResult(false);

    };



    useEffect(() => {
        if (clearJurisRow) {

            setCertificate((prevCertificate: any) => {
                const updatedAccounts = [...prevCertificate.accounts];
                const curAccount = { ...updatedAccounts[showAccount] };
                const jurisdiction = { ...curAccount.jurisdictionList[jurisdictionIdIndex] };
                const collector = jurisdiction.collectorName;
                const rateYear = jurisdiction.bill_year;
                const i = curAccount.summaryList.findIndex(
                    (obj: any) => obj.collector === collector && parseInt(obj.taxYear) === parseInt(rateYear)
                );
                // Reset jurisdiction data
                curAccount.jurisdictionList = [...curAccount.jurisdictionList];

                if (rateYear === '') {
                    // Only jurisdiction data reset
                    curAccount.jurisdictionList[jurisdictionIdIndex] = getResetJurisdiction(jurisdiction);
                    updatedAccounts[showAccount] = curAccount;
                    return {
                        ...prevCertificate,
                        accounts: updatedAccounts
                    };
                }

                if (i !== -1) {
                    const matchingJurisdictions = curAccount.jurisdictionList.filter(
                        (value: any) =>
                            value.collectorName === collector &&
                            parseInt(value.bill_year) === parseInt(rateYear)
                    );
                    curAccount.jurisdictionList[jurisdictionIdIndex] = getResetJurisdiction(jurisdiction);
                    if (matchingJurisdictions.length === 1) {
                        if (curAccount.summaryList.length === 1) {
                            setIsTaxSummaryReset(true);
                        } else {
                            curAccount.summaryList = curAccount.summaryList.filter((value1: any, p: any) => p !== i);
                        }
                    }
                    updatedAccounts[showAccount] = curAccount;
                    setAutoCalculate(true);
                    setUpdateTotalTaxValue(true);
                    return {
                        ...prevCertificate,
                        accounts: updatedAccounts
                    };
                }
                return prevCertificate;
            });

            setClearJurisRow(false);
        }
    }, [clearJurisRow]);

    useEffect(() => {
        if (updateTotalTotalTaxValue) {
            calculateTotalTaxValue(certificate, showAccount, setRender, setCertificate);
            setUpdateTotalTaxValue(false);
        }
    }, [updateTotalTotalTaxValue]);

    function getResetJurisdiction(original: any) {
        return {
            ...original,
            jurisdictionName: '',
            collectorName: '',
            jurisdictionId: '',
            collectorId: '',
            tax_rate: '',
            bill_year: '',
            baseDue: null,
            baseTax: null,
            currentMonthDue: null,
            nextMonthTaxDue: null,
            tax_rate_List: [],
            asOfDate: null,
            taxDataSource: null,
            collectorAccountNumber: '',
            nonCollecting: false,
            inActive: false,
            placeHolder: false
        };
    }


    function isJurisdictionChanged() {
        let temp1: any = [];

        let exist = vendorTaskList.length > 0 && vendorTaskList.findIndex((obj: any) => obj.type === "BONDS" && (obj.status === "PENDING")) > -1;

        certificate.accounts.map((accounts: any) => {
            if (accounts.jurisdictionList.length > 0) {
                accounts.jurisdictionList.map((jurisdiction: any) => {
                    jurisdiction.jurisdictionName != null && jurisdiction.jurisdictionName !== "" && temp1.push(jurisdiction.jurisdictionName);
                })
            }
        });

        if (defaultJurisdictionSize.length !== temp1.length && exist) {
            setIsJurisdictionUpdated(true);
        } else if (JSON.stringify(alphabeticalOrder(defaultJurisdictionSize)) !== JSON.stringify(alphabeticalOrder(temp1)) && exist) {
            setIsJurisdictionUpdated(true);
        } else {
            handleOrderResultSubmit();
        }
    }

    const handleOrderResultSubmit = (isAddToParent = false, currentCertificate?: any) => {
        // Use the passed certificate if available, otherwise use the one from the closure
        const certificateToUse = currentCertificate || certificate;
        setIsJurisdictionUpdated(false);

        const propertyList = certificateToUse.propertyIds
            .map((el: any) => el.id !== null ? el.id.trim() : el.id);

        let similarPropertyExist = (new Set(propertyList)).size !== certificateToUse.propertyIds.length;

        let invalidAssessmentExist = null;
        certificateToUse?.accounts?.some((account: any) => {
            const invalidAssessment = account.assessments?.find((assessment: any) => {
                return parseInt(assessment.taxYear) === 0;
            });
            if (invalidAssessment) {
                invalidAssessmentExist = account.propertyId;
                return true; // Exit the loop early since we found an invalid assessment
            }
            return false;
        });


        if (similarPropertyExist) {
            setWarningModalBody("Duplicate accounts found. Please resolve before saving.");
            setWarningModal(true);
        } else if (invalidAssessmentExist) {
            setWarningModalBody("Invalid assessment tax year found on " + invalidAssessmentExist + 'i.e 0.');
            setWarningModal(true);
        } else {

            let accountList;
            if (!isAddToParent || Object.keys(isAddToParent).length > 0) {
                const uniqueIndexes = removeDuplicateAndNegativeItems(updatedAccountIndexList);
                // Step 2: Add unique accounts from certificate.accounts based on uniqueIndexes to accountList
                accountList = uniqueIndexes.map((index: any) => certificateToUse.accounts[index]);

            } else {
                accountList = certificateToUse.accounts;
            }

            accountList.map((curAccount: any) => {
                let jurisdictions: any = [];

                curAccount?.jurisdictionList.map((el: any) => {

                    let levies: any = [];
                    let bonds = curAccount?.bondList.filter((obj: any) => obj.jurisdictionId === el.jurisdictionId);
                    let index = jurisdictions.findIndex((obj: any) => obj.collectorId === el.collectorId && obj.jurisdictionId === el.jurisdictionId);
                    let summary = curAccount?.summaryList.filter((obj: any) => obj.collector === el.collectorName && obj.taxYear === el.bill_year);
                    let jurisdictionId = el.jurisdictionId;
                    let jurisdictionName = el.jurisdictionName;
                    let collectorId = el.collectorId;
                    let collectorAccountNumber = summary.length > 0 ? summary[0].collectorAccountNumber : null;

                    if ((jurisdictionId != null && jurisdictionId !== "" && collectorId != null && collectorId !== "" && el.placeHolder === false) || el.placeHolder === true) {

                        let billYear = el.bill_year;
                        let baseDue = el.baseDue;
                        let baseTax = el.baseTax;
                        let taxRate = el.tax_rate ? parseFloat(el.tax_rate.toString().replaceAll(',', '')) : el.tax_rate;
                        let asOfDate = el.asOfDate;
                        let taxDataSource = el.taxDataSource;
                        let currentMonthDue = el.currentMonthDue ? parseFloat(el.currentMonthDue.toString().replaceAll(',', '')) : el.currentMonthDue;
                        let nextMonthDue = el.nextMonthTaxDue ? parseFloat(el.nextMonthTaxDue.toString().replaceAll(',', '')) : el.nextMonthTaxDue;
                        let placeHolder = el.placeHolder;
                        if (index === -1) {
                            let obj = {
                                billYear, taxRate, baseTax, baseDue, currentMonthDue, nextMonthDue
                            }
                            levies.push(obj)
                            jurisdictions.push({
                                jurisdictionId,
                                jurisdictionName,
                                collectorAccountNumber,
                                asOfDate,
                                taxDataSource,
                                collectorId,
                                levies,
                                bonds,
                                placeHolder
                            })
                        } else {

                            let temp1 = levies.findIndex((obj: any) => obj.taxYear === el.bill_year);

                            if (temp1 !== -1) {
                                levies[temp1] = {
                                    billYear, taxRate, baseTax, baseDue, currentMonthDue, nextMonthDue
                                }
                            } else {

                                let obj = {
                                    billYear, taxRate, baseTax, baseDue, currentMonthDue, nextMonthDue
                                }

                                levies.push(...jurisdictions[index].levies, obj);
                            }

                            jurisdictions[index] = {
                                jurisdictionId,
                                jurisdictionName,
                                collectorAccountNumber,
                                asOfDate,
                                taxDataSource,
                                collectorId,
                                levies,
                                bonds,
                                placeHolder
                            }
                        }
                    }

                });

                //check if you have any juris without levy////
                const withOutLevyJuris = curAccount?.bondList.reduce((result: any, item: any) => curAccount?.jurisdictionList.some((el: any) => item.jurisdictionId === null || item.jurisdictionId === '' || (el.jurisdictionId === item.jurisdictionId && el.jurisdictionName === item.jurisdictionName)) ? result : [...result, item], []);

                if (curAccount !== undefined) {
                    curAccount.jurisdictions = jurisdictions;

                }

                if (withOutLevyJuris !== undefined && withOutLevyJuris.length > 0) {

                    withOutLevyJuris.map((k: any) => {

                        let temp1 = jurisdictions.findIndex((obj: any) => obj.jurisdictionId === k.jurisdictionId && obj.jurisdictionName !== k.jurisdictionName);

                        if (temp1 !== -1) {
                            jurisdictions[temp1].bonds.push({
                                "jurisdictionName": k.jurisdictionName,
                                "jurisdictionId": k.jurisdictionId,
                                "bondsApproved": k.bondsApproved,
                                "bondsIssued": k.bondsIssued,
                                "standbyFee": k.standbyFee,
                                "taxDataSource": k.taxDataSource,
                                "asOfDate": k.asOfDate,
                            });
                        } else {

                            jurisdictions.push({
                                "jurisdictionId": k.jurisdictionId,
                                "jurisdictionName": k.jurisdictionName,
                                "collectorId": k.collectorId,
                                "collectorAccountNumber": false,
                                "taxDataSource": k.taxDataSource,
                                "asOfDate": k.asOfDate,
                                "levies": [],
                                "bonds": [{
                                    "jurisdictionName": k.jurisdictionName,
                                    "jurisdictionId": k.jurisdictionId,
                                    "bondsApproved": k.bondsApproved,
                                    "bondsIssued": k.bondsIssued,
                                    "standbyFee": k.standbyFee
                                }],
                                "placeHolder": k.placeHolder
                            });
                        }

                    });
                }

                if (curAccount !== undefined) {
                    //check if you have any tax suits without levy////
                    curAccount.taxSuits = curAccount?.taxSuits.reduce((result: any, item: any) => curAccount.taxSuits.some(() => item.payee === null || item.payee === '') ? result : [...result, item], []);

                    curAccount.taxSuits = curAccount?.taxSuits.reduce((result: any, item: any) => {
                        if (item.feeType === "") {
                            item.feeType = null;
                        }
                        return [...result, item];
                    }, []);
                }


            });

            const orderResultData = {
                "certificate": certificateToUse,
                "certificateOptions": {
                    "orderId": orderId,
                    "selectedCadYear": getCurrentTaxYear(),
                    "selectedTaxYear": getCurrentTaxYear(),
                },
            };

            if (isAddToParent) {
                return orderResultData;
            } else {
                let obj = {
                    "orderResultDTO": {
                        "certificate": {
                            "accounts": accountList.filter((el: any) => el !== undefined),
                            "certificateNotes": certificateToUse.certificateNotes
                        }, "certificateOptions": {
                            "orderId": orderId,
                            "selectedCadYear": getCurrentTaxYear(),
                            "selectedTaxYear": getCurrentTaxYear(),
                        }
                    }, "removedAccounts": removedAccountIds.filter((el: any) => el !== undefined)
                };

                saveOrderResult(obj);

            }
            setDisable(true);
        }

    }

    const handleGeneratePdf = async () => {
        try {
            const result = await generatePDf({
                orderId: orderId,
                customerId: customerId,
                tenant: tenant,
                checkValidation: true,
                cancelExistingTask: false
            }).unwrap();

            if (result['errorCode'] === 200) {
                setActiveTaskConfirmation(false);
                showToast("PDF created successfully!");
                setActiveTaskConfirmation(false);

                checkPdfExist({
                    'orderId': orderId, 'orderFileType': ["TaxCertificate", "CADPrintout"], 'type': 'New'
                });
                setIsPdfExist(pdfExistData)
                dispatch(tgxApi.util.invalidateTags(["getOrderResultByOrderId"]))

                if (result?.id) {
                    const fileUrl = `/ajax/view-file/${result.id}`;
                    const blobUrl = await fetchPdf(fileUrl); // your utility to convert file to blob URL
                    window.open(blobUrl, '_blank');
                }
            } else {
                if (result['message'] === "Can not generate PDF while task is incomplete!") {
                    setActiveTaskConfirmation(true);
                } else {
                    showToast(result["message"], "error");
                }
                setDisable(false);
            }
        } catch (error: any) {
            if (error?.data?.message === "Can not generate PDF while task is incomplete!") {
                setActiveTaskConfirmation(true);
            } else {
                showToast(error?.data?.message || "Something went wrong");
            }
        }
    };

    const handleGenerateCadPrintOutPdf = async () => {
        try {
            const result = await generateCadPrintoutPDf({
                orderId: orderId,
                certificateAccountDefaultDTOS: certificate.accounts
            }).unwrap();
            if (result['errorCode'] === 200) {
                showToast("PDF created successfully!");
                if (result?.id) {
                    const fileUrl = `/ajax/view-file/${result.id}`;
                    const blobUrl = await fetchPdf(fileUrl); // your utility to convert file to blob URL
                    window.open(blobUrl, '_blank');
                }
            }else{
                showToast(result["message"], "error");
                setDisable(false);
            }
        } catch (error: any) {
                showToast(error?.data?.message || "Something went wrong","error");
        }
    };

    useEffect(() => {
        if (isAddNewSummaryRow) {

            const updatedCertificate = updateSummarySectionRow(certificate, showAccount, jurisdictionIdIndex, taxYear);
            setCertificate(updatedCertificate);
            setIsAddNewSummaryRow(false);
        }
    }, [isAddNewSummaryRow]);

    return (
        <>
            {!orderQuery.data || !showForm ? <Preloader show={true} /> :
                <div>
                    <TopSection toggleAccountSection={toggleAccountSection}
                        setToggleAccountSection={setToggleAccountSection}
                        editable={editable}
                        isUserManager={isUserManager}
                        productSchema={"DEFAULT"}
                        formType={"Tax"}
                        productStatus={productStatus}
                        orderData={orderQuery}
                        curProduct={curProduct}
                        setIsSendNotification={setIsSendNotification}
                        setShowDeliveryConfirmation={setShowDeliveryConfirmation}
                        isSavedResult={isSavedResult}
                        setIsSavedResult={setIsSavedResult}
                        setProductStatus={setProductStatus}
                        productId={productId} setProductId={setProductId} setAssignedTo={setAssignTo}
                        moduleAvailableForCounty={moduleAvailableForCounty} taskList={vendorTaskList}
                        assignedTeam={assignedTeam}
                        setAssignedTeam={setAssignedTeam}
                        setShowTeamListModal={setShowTeamListModal} showTeamListModal={showTeamListModal}
                        handleOrderResultSubmit={isJurisdictionChanged}
                        isPdfExist={isPdfExist}
                        unAcknowledged={unAcknowledged}
                        isValidDataForPdfGenerate={isValidDataForPdfGenerate}
                        setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                        handleGeneratePdf={handleGeneratePdf}
                        propertyResultTaxList={propertyResultTaxList}
                        setPropertyResultTaxList={setPropertyResultTaxList}
                        taxCheckedList={taxCheckedList}
                        setTaxCheckedList={setTaxCheckedList}
                        certificateOptions={certificateOptions}
                        handleMarkAsComplete={handleMarkAsComplete}
                        disable={disable}
                        generatePDfApi={generatePDfApi.isLoading}
                        saveOrderResultApi={saveOrderResultApi.isLoading}
                        markAsCompletedApi={markAsCompletedApi.isLoading}
                        requiresQc={requiresQc}
                        primaryCollectorId={primaryCollectorId}
                        certificate={certificate}
                        updateAccountList={updateAccountList}
                        handleGenerateCadPrintOutPdf={handleGenerateCadPrintOutPdf}
                        generateCadPrintoutPDfApi={generateCadPrintoutPDfApi.isLoading}

                    />

                    <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                        <div className="col-span-2">
                            {toggleAccountSection &&
                                <LeftBar setAddedNewAccount={setAddedNewAccount} certificate={certificate}
                                    setCertificate={setCertificate}
                                    setCertNotes={setCertNoteList}
                                    showAccount={showAccount} setShowAccount={setShowAccount}
                                    orderId={orderId} certNoteList={certNoteList}
                                    customerNoteList={customerNoteList}
                                    setIsSavedResult={setIsSavedResult} noteType={"TAX"}
                                    showDeleteAccountConfirmation={showDeleteAccountConfirmation}
                                    setShowDeleteAccountConfirmation={setShowDeleteAccountConfirmation}
                                    similarAccountList={similarAccountList}
                                    vendorTaskList={sortByKeysPriority(vendorTaskList, ["type"], ["asc"])}
                                    productType={"TAX_CERTIFICATE"}
                                    setIsFetchSimilarAccountList={setIsFetchSimilarAccountList}
                                    isFetchSimilarAccountList={isFetchSimilarAccountList}
                                    cadInfoData={cadInfoData}
                                    editable={editable}
                                    qcResultList={qcResultList}
                                    unAcknowledged={unAcknowledged}
                                    qcLogicResultData={qcLogicResultDataApiResponse}
                                    haveOrderResult={haveOrderResult}
                                    similarTaxAccountListResponse={similarTaxAccountListResponse}
                                    propertyResultTaxList={propertyResultTaxList}
                                    setPropertyResultTaxList={setPropertyResultTaxList}
                                    taxCheckedList={taxCheckedList}
                                    setTaxCheckedList={setTaxCheckedList}
                                    productId={productId}
                                    orderData={orderQuery}
                                    taxAccountNumber={taxAccountNumber}
                                    setTaxAccountNumber={setTaxAccountNumber} address={address}
                                    setAddress={setAddress} legalDescription={legalDescription}
                                    setLegalDescription={setLegalDescription}
                                    ownerName={ownerName}
                                    setOwnerName={setOwnerName}
                                    orderResultData={orderResult}
                                    setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                                    assignTo={assignTo}
                                    addAccountSelectedProperty={addAccountSelectedProperty}
                                    setAddAccountSelectedProperty={setAddAccountSelectedProperty}
                                    countyData={countyDataApiResponse}
                                    setSelectedCloneAccountList={setSelectedCloneAccountList}
                                    showAccountCloneModal={showAccountCloneModal}
                                    setShowAccountCloneModal={setShowAccountCloneModal}
                                    removedAccountIds={removedAccountIds}
                                    updatedAccountIndexList={updatedAccountIndexList}
                                    setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    setIsFetchLinkedAccountList={setIsFetchLinkedAccountList}
                                    linkedListLoader={isFetching}
                                    getPropertyPickerResultApi={getPropertyPickerResultApi}
                                    getPropertyPickerResult={getPropertyPickerResult}
                                    ordersInSubdivisionList={ordersInSubdivisionList}
                                    subdivisionId={subdivisionId}
                                    productStatuses={productStatuses}
                                    setProductStatuses={setProductStatuses}
                                />
                            }
                        </div>
                        <div className={toggleAccountSection ? "col-span-10" : "col-span-12"}>
                            <SummaryInfoSection orderData={orderQuery}
                                certificate={certificate}
                                setCertificate={setCertificate}
                                orderId={orderId}
                                setIsSavedResult={setIsSavedResult}
                                deleteNote={deleteNote}
                                editable={editable}
                                customerOrderNumber={orderQuery?.data?.customerOrderNumber}
                                orderResultModifiedDate={orderResultModifiedDate}
                                productStatus={productStatus}
                                assignTo={assignTo}
                                showAccount={showAccount}
                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                            />

                            <RequestedInfoSection orderData={orderQuery} certificate={certificate}
                                showAccount={showAccount}
                                isHoaEditor={false} />

                            <AccountInformation orderData={orderQuery}
                                certificate={certificate}
                                showAccount={showAccount}
                                setCertificate={setCertificate}
                                deleteNote={deleteNote}
                                editable={editable}
                                customerId={customerId}
                                primaryCollector={primaryCollector}
                                isSavedResult={isSavedResult}
                                setIsSavedResult={setIsSavedResult}
                                countyData={countyDataApiResponse} setAccounts={setAccounts}
                                accounts={accounts}
                                setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                addParentAccountsForSubdivision={addParentAccountsForSubdivision}
                                setSubdivisionId={setSubdivisionId}
                            />
                        </div>
                    </div>
                    <div className="md:grid sm:block grid-cols-12 gap-3 text-sm">
                        {toggleAccountSection && <div className={"col-span-2 mt-2"}>
                            {(haveOrderResult || (certificate?.accounts?.length > 0 && certificate?.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && certificate.accounts[showAccount]['cadInformation'].length > 0)) &&
                                <div
                                    className={"vendor_task_sidebar bg-text-1 rounded-[7px] shadow-[0_3px_10px_rgb(0_0_0_/20%)]"}>
                                    <div className={"bg-highlight-5 flex items-center text-text-0 p-2"}>
                                        <p className="mb-0">CAD
                                            Information {certificate?.accounts?.length > 0 && certificate.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && '(' + certificate.accounts[showAccount]['cadInformation'].length + ')'} </p>
                                        {certificate?.accounts?.length > 0 && certificate.accounts[showAccount] !== undefined && certificate.accounts[showAccount]['cadInformation'] && certificate.accounts[showAccount]['cadInformation'].length > 0 &&
                                            <i className={loadingCadInfo ? "fas fa-sync fa-spin ml-auto h-4" : "fa fa-refresh ml-auto cursor-pointer"}
                                                title={'Refresh CAD information'} onClick={(e) => {
                                                    if (editable) {
                                                        e.preventDefault();
                                                        setReloadCadInformation(true);
                                                    }
                                                }}
                                            />}
                                    </div>
                                    <div
                                        className={certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length > 5 ? "tax_list table-responsive side_bar_table" : "tax_list table-responsive side_bar_table"}>
                                        <table
                                            className={"table table_data tax-summary-table margin_bottom_custom"}>
                                            <tbody>
                                                {certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length === 0 &&
                                                    <tr>
                                                        <td colSpan={3}>No taxing units found</td>
                                                    </tr>}
                                                {certificate.accounts.length > 0 && certificate.accounts[showAccount]?.cadInformation && certificate.accounts[showAccount]?.cadInformation.length > 0 && sortCadInfo(certificate.accounts[showAccount]?.cadInformation).map((curUnit: any) => {
                                                    return (<tr className="border-t border-surface-5">
                                                        <td>
                                                            <a
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                href={'/jurisdictions' + (!curUnit['jurisdictionId'] ? '' : ('/' + curUnit['jurisdictionId']))}
                                                                title={curUnit?.taxingUnitSource ?? '-'}
                                                                className="text-highlight-4 hover:underline"
                                                            >
                                                                {curUnit?.taxingUnit}
                                                            </a>

                                                        </td>
                                                        <td>
                                                            <span
                                                                title={curUnit?.jurisdictionName}>{curUnit?.jurisdictionName > 10 ? curUnit?.jurisdictionName.substring(0, 10) + '...' : curUnit?.jurisdictionName}
                                                            </span>
                                                        </td>
                                                    </tr>)
                                                })}

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            }
                        </div>
                        }
                        <div className={toggleAccountSection ? "col-span-10" : "col-span-12"}>
                            <div className={'bg-text-1 rounded-b-[7px] shadow-md p-2'}>
                                <div className="detail-style unset_border_top bg-text-1 rounded-[7px] shadow-md">
                                    <JurisdictionSection curAccount={certificate.accounts[showAccount]}
                                        setShowAccount={setShowAccount}
                                        accounts={accounts}
                                        setAccounts={setAccounts}
                                        setIsSavedResult={setIsSavedResult}
                                        autoCalculate={autoCalculate}
                                        setAutoCalculate={setAutoCalculate}
                                        certificate={certificate}
                                        setCertificate={setCertificate}
                                        showAccount={showAccount}
                                        jurisdictionIdIndex={jurisdictionIdIndex}
                                        setJurisdictionIdIndex={setJurisdictionIdIndex}
                                        removeJurisdiction={removeJurisdiction}
                                        setRemoveJurisdiction={setRemoveJurisdiction}
                                        setIsAddNewSummaryRow={setIsAddNewSummaryRow}
                                        setTaxYear={setTaxYear}
                                        clearJurisRow={clearJurisRow}
                                        setClearJurisRow={setClearJurisRow}
                                        setUpdateTotalTaxValue={setUpdateTotalTaxValue}
                                        editable={editable}
                                        county={orderQuery?.data.countyId}
                                        countyName={orderQuery?.data.county}
                                        state={orderQuery?.data.state}
                                        orderId={orderId}
                                        setRender={setRender}
                                        primaryCollector={primaryCollector}
                                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    />
                                    <TaxSuitsSection curAccount={certificate.accounts[showAccount]}
                                        setIsSavedResult={setIsSavedResult}
                                        certificate={certificate}
                                        setCertificate={setCertificate}
                                        showAccount={showAccount}
                                        editable={editable}
                                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    />
                                    <CommentNoteSection
                                        type={"Tax Suit Notes"}
                                        curAccount={certificate.accounts[showAccount]?.taxSuitNotes}
                                        certificate={certificate}
                                        setCertificate={setCertificate}
                                        orderId={orderId}
                                        showAccount={showAccount}
                                        setIsSavedResult={setIsSavedResult}
                                        deleteNote={deleteNote} editable={editable}
                                        setShowAdd={setShowAddTaxSuitCommentModal}
                                        setShowUpdate={setShowUpdateTaxSuitCommentModal}
                                        isTaxSuit={true}
                                        noteType={"taxSuitNotes"}
                                        length={certificate.accounts[showAccount]?.taxSuitNotes + 1}
                                        setIndex={setNoteIndex}
                                    />
                                    <BondSection
                                        curAccount={certificate.accounts[showAccount]}
                                        certificate={certificate}
                                        setCertificate={setCertificate}
                                        index={showAccount}
                                        setShowAccount={setShowAccount}
                                        setIsSavedResult={setIsSavedResult}
                                        showAccount={showAccount}
                                        editable={editable}
                                        county={orderQuery?.data?.countyId}
                                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                                    />
                                </div>
                            </div>
                        </div>

                    </div>


                    {showAddTaxSuitCommentModal && <EditorAddEditNoteForm title={"Add Tax Suit Note"}
                        show={showAddTaxSuitCommentModal}
                        setShow={setShowAddTaxSuitCommentModal}
                        index={null}
                        certificate={certificate}
                        setCertificate={setCertificate}
                        orderId={orderId}
                        showAccount={showAccount}
                        setIsSavedResult={setIsSavedResult}
                        length={certificate.accounts[showAccount]?.taxSuitNotes.length + 1}
                        isTaxSuit={true}
                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                    />}

                    {showUpdateTaxSuitCommentModal && <EditorAddEditNoteForm title={"Update Tax Suit Note"}
                        show={showUpdateTaxSuitCommentModal}
                        setShow={setShowUpdateTaxSuitCommentModal}
                        index={noteIndex}
                        certificate={certificate}
                        setCertificate={setCertificate}
                        orderId={orderId}
                        showAccount={showAccount}
                        setIsSavedResult={setIsSavedResult}
                        isTaxSuit={true}
                        setUpdatedAccountIndexList={setUpdatedAccountIndexList}
                    />}
                    {warningBondModal ? <ConfirmationModal title={"Delete Bond"}
                        bodyMessage={<><p>Delete Jurisdiction will delete existing
                            related bond as
                            well.</p>
                            <p>Continue ?</p></>}
                        onSubmit={removeJurisdictionAndBonds} show={warningBondModal}
                        setShow={setWarningBondModal} /> : <></>}


                    {activeTaskConfirmation ? <GenerateActivePdf show={activeTaskConfirmation}
                        setShow={setActiveTaskConfirmation} orderId={orderId}
                        customerId={customerId}
                        tenant={tenant} type={"taxCert"}
                        productType={products.type}
                        setIsValidDataForPdfGenerate={setIsValidDataForPdfGenerate}
                        orderResult={orderResult.data}
                        productSchema={"Default"}
                        setIsPdfExist={setIsPdfExist}
                    /> : <></>}

                    {showDeliveryConfirmation && isArray(docList) &&
                        <PdfDeliveryConfirmationModal title={"Deliver Documents"}
                            body={"Select the documents you would like to deliver"}
                            docList={docList}
                            deliveryEmail={deliveryEmail}
                            setDeliveryEmail={setDeliveryEmail}
                            show={showDeliveryConfirmation}
                            setShow={setShowDeliveryConfirmation}
                            disable={disable}
                            setDisable={setDisable}
                            orderId={orderId}
                            productType={products.type}
                            isSendNotification={isSendNotification}
                            fileType={"TaxCertificate"}
                            isHoaOrder={false}
                            orderData={orderQuery}
                            includeCadPrintout={orderQuery?.data?.branchDTO?.includeCadPrintout}
                            setDocList={setDocList}
                        />
                    }

                    {isJurisdictionUpdated && <ConfirmationModal title={"Warning"}
                        bodyMessage={<><p>Updating Jurisdiction will cancel
                            existing Bonds
                            Task.</p><p>Continue
                                ?</p></>}
                        onSubmit={async () => {
                            await handleOrderResultSubmit();
                        }}
                        show={isJurisdictionUpdated}
                        setShow={setIsJurisdictionUpdated} />}

                    {warningModal && <ConfirmationModal title={"Alert"}
                        bodyMessage={warningModalBody}
                        onSubmit={null} show={warningModal}
                        setShow={setWarningModal} />}

                    {lockEditorPopUp &&
                        <LockConfirmationPopUp formType={"taxCert"} show={lockEditorPopUp} setShow={setLockEditorPopUp}
                            orderId={orderId} setEditable={setEditable} productId={productId} />
                    }
                </div>
            }
        </>
    )
}
export default TaxDetailTabSection

export function updateSummaryRowInfo(summaryList: any[], sumList: any[], index: number): any[] {
    if (summaryList[index] === undefined) return summaryList;

    const updatedRow = { ...summaryList[index] };


    const reduceSum = (key: string) => {
        return sumList.reduce((prev: any, cur: any) => {
            const val = cur[key];
            if (val !== '' && val !== null && prev !== null) return prev + parseFloat(val);
            if (val === '' || val === null || prev === null) return null;
            return prev;
        }, 0);
    };

    updatedRow['baseTax'] = reduceSum('baseTax');
    updatedRow['baseDue'] = reduceSum('baseDue');
    updatedRow['currentMonthDue'] = reduceSum('currentMonthDue');
    updatedRow['nextMonthTaxDue'] = reduceSum('nextMonthTaxDue');

    const asOfDateArray: number[] = sumList
        .filter((cur: any) => cur['asOfDate'] !== null && cur['asOfDate'] !== '')
        .map((cur: any) => moment(cur['asOfDate'], 'YYYY-MM-DD').valueOf());

    updatedRow['asOfDate'] = asOfDateArray.length === 0 ? null : new Date(Math.min(...asOfDateArray));

    // return new updated list
    const updatedList = [...summaryList];
    updatedList[index] = updatedRow;

    return updatedList;
}



export function dummyAssessmentList() {
    let currentTaxYear = getCurrentTaxYear();
    let desiredYear = doesCurrentTaxYearMatchCurrentYear() ? currentTaxYear + 1 : currentTaxYear - 1;

    let assessment = {
        "taxYear": desiredYear > currentTaxYear ? currentTaxYear : desiredYear,
        "improvementMarketValue": null,
        "landMarketValue": null,
        "agMarketValue": null,
        "overrideAppraisedValue": null,
        "overrideAssessedValue": null,
        "agTimberValue": null,
        "agLossValue": null,
        "RsteadCapValue": 0,
        "exemptions": [],
        "assessedValue": null,
        "agriculturalValue": null,
        "landTotalValue": null,
        "overrideAgValue": null,
        "appraisedValue": null,
        "certified": false,
        "overrideLandTotalValue": null,
        "woExemptionAmount": null,
        "overrideWoExemptionAmount": null,
        "withExemptionEstimate": null,
        "withExemptionEstimateOverride": null,
    };

    return [
        {
            ...assessment,
            "taxYear": desiredYear > currentTaxYear ? currentTaxYear : desiredYear,
        },
        {
            ...assessment,
            "taxYear": desiredYear > currentTaxYear ? desiredYear : currentTaxYear,
        }
    ]
}

export function getUniqueLatestYearJurisdictions(jurisdictionList: any) {
    let list = [];
    for (let i = 0; i < jurisdictionList.length; i++) {
        if (jurisdictionList[i]['jurisdictionId'] !== '' && jurisdictionList[i]['jurisdictionId'] !== null && jurisdictionList[i]['inActive'] !== true && jurisdictionList[i]['nonCollecting'] !== true) {
            let index: any = list.findIndex(obj => obj.jurisdictionName === jurisdictionList[i]['jurisdictionName']);
            if (index > -1) {
                if (parseInt(jurisdictionList[i]['bill_year']) > parseInt(list[index]['bill_year'])) {
                    list[index] = jurisdictionList[i];
                }
            } else {
                list.push(jurisdictionList[i]);
            }
        }
    }
    return list;
}

export function bondExist(bondList: any, jurisdictionId: any) {
    return bondList.filter((el: any) => {
        if (el.jurisdictionId === jurisdictionId && el.jurisdictionId !== '') {
            return el;
        }
    }
    )
}